const ScenarioActionType = {
    MAPPING: 'MAPPING',
    ADD_SAVING_COUNT: 'ADD_SAVING_COUNT',
    SHOULD_UPDATE_GRAPH: 'SHOULD_UPDATE_GRAPH',
    WEB_VIEW_LIST: 'WEB_VIEW_LIST',
    DRAGGING_CARD: 'DRAGGING_CARD',
    MAP_INTENT_TO_STEP: 'MAP_INTENT_TO_STEP',
    SCAN_ERROR: 'SCAN_ERROR',
    DIALOG_ACT: 'DIALOG_ACT',
    SUPPORT_CATEGORY_LIST: 'SUPPORT_CATEGORY_LIST',
    GRAPH_NODE_LIST: 'GRAPH_NODE_LIST',
    ACTIVE_REMINDER: 'ACTIVE_REMINDER',
    // active
    ACTIVE_DATA: 'ACTIVE_DATA',
    // scenario
    CREATE_SCENARIO: 'CREATE_SCENARIO',
    UPDATE_SCENARIO: 'UPDATE_SCENARIO',
    DELETE_SCENARIO: 'DELETE_SCENARIO',
    POSITION_SCENARIO: 'POSITION_SCENARIO',
    // step
    CREATE_STEP: 'CREATE_STEP',
    UPDATE_STEP: 'UPDATE_STEP',
    DELETE_STEP: 'DELETE_STEP',
    POSITION_STEP: 'POSITION_STEP',
    // card
    CREATE_CARD: 'CREATE_CARD',
    UPDATE_CARD: 'UPDATE_CARD',
    DELETE_CARD: 'DELETE_CARD',
    POSITION_CARD: 'POSITION_CARD',
    UPDATE_CARD_CONDITION: 'UPDATE_CARD_CONDITION',
    // step config
    CREATE_STEP_CONFIG: 'CREATE_STEP_CONFIG',
    UPDATE_STEP_CONFIG: 'UPDATE_STEP_CONFIG',
    DELETE_STEP_CONFIG: 'DELETE_STEP_CONFIG',
    // variable
    VARIABLE_LIST: 'VARIABLE_LIST',
    LOAD_VARIABLE: 'LOAD_VARIABLE',
    CREATE_VARIABLE: 'CREATE_VARIABLE',
    UPDATE_VARIABLE: 'UPDATE_VARIABLE',
    DELETE_VARIABLE: 'DELETE_VARIABLE'
}

export default ScenarioActionType
